var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1828_46109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2245 11.8828C11.5525 12.51 11.0107 13.2634 10.63 14.1C10.11 14.05 9.57 14 9 14C6.72 14.04 4.84 14.43 3.34 15.18C1.84 15.93 1.06 16.86 1 18V20H10.67C11.83 22.44 14.3 24 17 24C18.3438 24.0023 19.6596 23.6166 20.7896 22.8893C21.9196 22.1621 22.8155 21.1241 23.37 19.9C23.751 19.0635 23.9634 18.1601 23.9952 17.2415C24.027 16.3229 23.8775 15.407 23.5553 14.5462C23.2331 13.6853 22.7444 12.8964 22.1172 12.2245C21.49 11.5525 20.7366 11.0107 19.9 10.63C19.0635 10.249 18.1601 10.0366 17.2415 10.0048C16.3229 9.97298 15.407 10.1225 14.5462 10.4447C13.6853 10.7669 12.8964 11.2556 12.2245 11.8828ZM11.81 5.17C11.06 4.42 10.12 4.03 9 4C7.88 4.03 6.94 4.42 6.19 5.17C5.44 5.92 5.07 6.86 5.07 8C5.07 9.14 5.44 10.08 6.19 10.83C6.94 11.58 7.88 11.95 9 11.95C10.12 11.95 11.06 11.58 11.81 10.83C12.56 10.08 12.93 9.14 12.93 8C12.93 6.86 12.56 5.92 11.81 5.17ZM20.5355 20.5355C19.5979 21.4732 18.3261 22 17 22C15.6739 22 14.4021 21.4732 13.4645 20.5355C12.5268 19.5979 12 18.3261 12 17C12 15.6739 12.5268 14.4021 13.4645 13.4645C14.4021 12.5268 15.6739 12 17 12C18.3261 12 19.5979 12.5268 20.5355 13.4645C21.4732 14.4021 22 15.6739 22 17C22 18.3261 21.4732 19.5979 20.5355 20.5355Z",
    fill: "#464E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14H17.5V16.82L19.94 18.23L19.19 19.53L16 17.69V14Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1828_46109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLog);
export default __webpack_public_path__ + "static/media/activityLog.859a28b984383141be8f126a64cee380.svg";
export { ForwardRef as ReactComponent };